import { render, staticRenderFns } from "./EnclosedDetail.vue?vue&type=template&id=43d5e230&"
import script from "./EnclosedDetail.vue?vue&type=script&lang=js&"
export * from "./EnclosedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports